"use client";
import { Button } from "@/components/ui/Button";
import { useTranslationDetector } from "@/hooks/useTranslationDetector";
import { Link, useRouter } from "@/i18n/navigation";
import { commonService } from "@/services/commonService";
import { byPrefixAndName } from "@awesome.me/kit-12cf79935c/icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { redirect, usePathname } from "next/navigation";
import { useEffect } from "react";

export default function NotFoundPage() {
  const router = useRouter();
  const pathname = usePathname();
  const t = useTranslationDetector("common");

  const checkRedirect = async (params) => {
    const response = await commonService.checkRedirect({ Url: pathname });
    if (response.ShouldRedirect) {
      redirect(`${response.RedirectUrl}`);
    }
  };

  const popularPages = [
    { href: "/flight", label: t("Flight"), icon: "new-flight" },
    { href: "/hotel", label: t("hotel"), icon: "new-hotel" },
    { href: "/bus-ticket", label: t("bus"), icon: "new-bus" },
    { href: "/car-rental", label: t("car"), icon: "new-car" },
    { href: "/ferry", label: t("ferry"), icon: "new-ferry" },
  ];

  useEffect(() => {
    // checkRedirect();
  }, [pathname]);

  return (
    <div className="py-16 text-center">
      <div className="mx-auto max-w-md px-4">
        {/* 404 Number */}
        <h1 className="mb-4 text-6xl font-semibold text-gray-800">404</h1>

        {/* Title */}
        <h2 className="mb-4 text-2xl font-semibold text-gray-700">
          {t("notFoundTitle")}
        </h2>

        {/* Description */}
        <p className="mb-8 text-gray-600">{t("notFoundDescription")}</p>

        {/* Action Buttons */}
        <div className="mb-8 space-y-3">
          <Button onClick={() => router.push("/")} className="w-full">
            {t("home")}
          </Button>

          <Button
            onClick={() => router.back()}
            variant="outline"
            className="w-full"
          >
            {t("back")}
          </Button>
        </div>

        {/* Popular Pages */}
        <div className="mb-8">
          <h3 className="mb-6 text-lg font-medium text-gray-700">
            {t("popularPages")}
          </h3>
          <div className="flex justify-center divide-x divide-gray-200">
            {popularPages.map((page, index) => (
              <Link
                key={index}
                href={page.href}
                className="flex items-center gap-2 px-3 py-2 text-sm"
              >
                <FontAwesomeIcon
                  icon={byPrefixAndName.fak[page.icon]}
                  className="h-4 w-4 text-gray-600"
                />
                <span>{page.label}</span>
              </Link>
            ))}
          </div>
        </div>

        {/* Help Text */}
        <div className="text-sm text-gray-500">
          <Link
            href="/contact"
            className="text-blue-600 underline hover:text-blue-800"
          >
            {t("contactUs")}
          </Link>
        </div>
      </div>
    </div>
  );
}
